import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";

const Dashboard = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    transition: "0.3s",
    cursor: "pointer",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const cards = [
    {
      title: "User Password",
      description: "List of your class student's username and password.",
      icon: "fas fa-user text-yellow-400",
      link: "/user-password",
    },
    {
      title: "Class Reports",
      description: "View and manage class performance reports.",
      icon: "fas fa-chart-bar text-green-600",
      link: "/class-reports",
    },
    {
      title: "Add Attendance",
      description: "Add and manage student attendance.",
      icon: "fas fa-calendar-check text-blue-500",
      link: "/student-attendance",
    },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="w-full max-w-7xl mx-auto px-4 py-5">
       

        {/* Quick Actions Row */}
        <div className="bg-white rounded-xl p-4 shadow-sm border mb-6">
          <h2 className="font-semibold text-gray-700 text-lg mb-3">Quick Actions</h2>
          <div className="flex overflow-x-auto gap-4 hide-scrollbar pb-2">
            {[
              { to: "/homework", icon: "fa-pencil", label: "Homework", color: "bg-blue-500" },
              { to: "/test-schedule", icon: "fa-clock", label: "Today's Tests", color: "bg-purple-500" },
              { to: "/add-notification", icon: "fa-bullhorn", label: "Announcements", color: "bg-yellow-500" },
            ].map((item, i) => (
              <Link to={item.to} key={i} className="flex-shrink-0">
                <div className={`${item.color} text-white rounded-lg px-4 py-3 flex items-center gap-2 shadow`}>
                  <i className={`fas ${item.icon}`}></i>
                  <span>{item.label}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Cards for different actions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <Link key={index} to={card.link} className="w-full">
              <div style={cardStyle} className="hover:scale-[1.02] transition">
                <i className={`${card.icon} text-3xl mr-3`} style={iconStyle}></i>
                <div>
                  <h2 style={heading}>{card.title}</h2>
                  <p style={subText}>{card.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
